import { atom } from 'jotai';
export interface CommonUserInfo {
  user_id: string;
  user_unique_name: string;
  avatar_url: string;
  gender?: GenderEnum;
  has_photo_authorization?: boolean;
  user_nick_name?: string;
  description?: string;
  followers_count?: number;
  is_following?: number;
  is_followed?: number;
}
export enum GenderEnum {
  UNKNOWN = 0,
  MALE = 1,
  FEMALE = 2,
  SECRET = 3,
  CUSTOM = 4,
}
export interface GetIdeaLandingPageRespWrap {
  /**
   *报告Idea列表
   */
  ideas?: UserIdea[];
  /**
   *创建事件
   */
  create_time?: number;
  /**
   *选择的头像挂件
   */
  pendant_id?: string;
  /**
   *用户信息
   */
  user_info?: CommonUserInfo;
}
export interface UserIdea {
  /**
   *idea信息
   */
  idea?: IdeaInfo;
  /**
   *文章信息
   */
  item?: ItemInfo;
  /**
   *投稿数
   */
  post_cnt?: number;
}
export interface ItemInfo {
  /**
   *文章ID
   */
  item_id?: number;
  /**
   *封面图
   */
  cover_img?: string;
}
export interface IdeaInfo {
  /**
   *ideaID
   */
  idea_id?: number;
  /**
   *icon（详情页展示）
   */
  icon?: string;
  /**
   *选项icon（选择页使用）
   */
  option_icon?: string;
  /**
   *选项背景色（选择页使用）
   */
  bg_color?: string;
  /**
   *文案
   */
  text?: string;
  /**
   *关联的hashtagid
   */
  forum_id?: number;
  /**
   *活动主话题ID
   */
  main_forum_id?: number;
}

interface GetIdeaLandingPageRespWrapClone extends GetIdeaLandingPageRespWrap {
  campaignId?: string;
  sharePlatform?: string;
}

export const ThingsStore = atom<GetIdeaLandingPageRespWrapClone>({});

export const $ThingsData = atom(
  (get) => {
    return get(ThingsStore);
  },
  (get, set, args: Record<keyof GetIdeaLandingPageRespWrap[], any>) => {
    const old = get(ThingsStore);
    set(ThingsStore, { ...old, ...args });
  },
);
